import { useQuery } from 'wagmi';
import { apiClient } from '../base/request';
export const useGetTokenPriceById = (tokenAsset) => {
    const id = tokenAsset?.UCID;
    return useQuery(['tokenPriceById', id], async () => {
        return (await apiClient.get(`/token/getPrice?symbol=${id}&pattern=id`)).data?.data;
    }, {
        enabled: !!id && !!tokenAsset,
        staleTime: 1000 * 60 * 10,
        cacheTime: 1000 * 60 * 60,
        refetchOnMount: false,
        retry: false,
    });
};
